import React from 'react';
import SVGIcon from '@atlaskit/icon/svg';
import { B400, N10, N100 } from '@atlaskit/theme/colors';
/**
 * __Radio icon__
 *
 * Used to visually represent the selected state in DropdownItemRadio
 *
 * @internal
 */
var RadioIcon = function RadioIcon(_ref) {
  var checked = _ref.checked;
  return /*#__PURE__*/React.createElement(SVGIcon, {
    label: "",
    size: "medium",
    primaryColor: checked ? "var(--ds-background-selected-bold, ".concat(B400, ")") : "var(--ds-background-input, ".concat(N10, ")"),
    secondaryColor: checked ? "var(--ds-icon-inverse, ".concat(N10, ")") : 'transparent'
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "currentColor",
    cx: "12",
    cy: "12",
    r: "6",
    stroke: checked ? "var(--ds-border-selected, ".concat(B400, ")") : "var(--ds-border-input, ".concat(N100, ")"),
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "inherit",
    cx: "12",
    cy: "12",
    r: "2"
  })));
};
export default RadioIcon;